import React from 'react';
import { Link } from 'react-router-dom';
const ARTICLE_PATH = '/news/don-callaway-ferrari-case';
const FOOTER_LINKS = ['About', 'Contact', 'Editorial Policy', 'Privacy Policy', 'Terms'];
export function SiteFooter() {
  return <footer className="mt-20 border-t border-rule bg-paper-tint" data-id="element-53" data-mp="3mg831s5ebct1">
      <div className="mx-auto max-w-shell px-5 py-12 sm:px-8" data-id="element-54" data-mp="3hizmtx3t5iuf">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-55" data-mp="3hglrro94o6mv">
          <div data-id="element-56" data-mp="3deruzr21zmrz">
            <Link to={ARTICLE_PATH} className="font-sans text-[15px] font-bold uppercase tracking-[0.18em] text-ink" data-id="element-57" data-mp="38hrpbh948m1e">
              California News
            </Link>
            <p className="mt-2 font-sans text-[13px] text-ink-muted" data-id="element-58" data-mp="2yjtzipblyh6o">californianews.online</p>
          </div>

          <nav aria-label="Footer" data-id="element-59" data-mp="11rttxkhp78u3">
            <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-60" data-mp="11qs7ykz591xl">
              {FOOTER_LINKS.map(link => <li key={link} data-id="element-61" data-mp="wt0gfs2evhtx">
                  <Link to={ARTICLE_PATH} className="font-sans text-[13px] text-ink-soft transition-colors duration-150 ease-out hover:text-ink" data-id="element-62" data-mp="15qva55gw0thu">
                    {link}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-10 border-t border-rule pt-6" data-id="element-63" data-mp="10stqojfjus5u">
          <p className="font-sans text-[12px] text-ink-faint" data-id="element-64" data-mp="1ohcy6wqrz0wv">
            © California News. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}